import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import Button from "../../../../common/ekedc-components/button/Button";
import styles from "./transfer-unit-verify-meter.module.scss";
import { ApplicationRoutes } from "../../../../routes";

const LockIcon: React.FC = () => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
		<path
			d="M16.5 10v-2a5.5 5.5 0 1 0-11 0v2M5 10h12a1.5 1.5 0 0 1 1.5 1.5v6A1.5 1.5 0 0 1 17 19H5a1.5 1.5 0 0 1-1.5-1.5v-6A1.5 1.5 0 0 1 5 10Z"
			stroke="#864ECE"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none"
		/>
	</svg>
);

interface TokenField {
	label: string;
	value: string;
}

export const TransferUnitVerifyMeterPage: React.FC = () => {
	const navigate = useNavigate();
	const [fields, setFields] = useState<TokenField[]>([
		{ label: "Unit Amount (Last month)", value: "" },
		{ label: "Unit Amount (2 months ago)", value: "" },
		{ label: "Unit Amount (3 months ago)", value: "" },
	]);
	const [submitting, setSubmitting] = useState(false);

	const setFieldValue = (idx: number, value: string) => {
		setFields(prev => prev.map((f, i) => (i === idx ? { ...f, value } : f)));
	};

	const allFilled = fields.every(f => Number.parseFloat(f.value) > 0);

	const handleVerify = async () => {
		if (!allFilled || submitting) return;
		setSubmitting(true);
		// Backend verify endpoint to be wired here; for now route to the next step.
		// Placeholder: simulate quick verify then continue.
		setTimeout(() => {
			setSubmitting(false);
			navigate(`/${ApplicationRoutes.TRANSFER_UNIT_RECIPIENT}`);
		}, 300);
	};

	return (
		<CustomerPageLayout
			title="Verify Your Meter"
			onBack={() => navigate(-1)}
			containerClass={styles.layoutContainer}
			contentContainerClass={styles.layoutContent}
		>
			<form
				className={styles.page}
				onSubmit={e => {
					e.preventDefault();
					handleVerify();
				}}
			>
				{/* <header className={styles.headerRow}>
					<button type="button" className={styles.backButton} onClick={() => navigate(-1)} aria-label="Go back">
						<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
							<path
								d="M14.6667 5.5L9.16667 11L14.6667 16.5"
								stroke="var(--app-primary-text)"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
					<h1 className={styles.title}>Verify Your Meter</h1>
				</header> */}

				<div className={styles.scrollContent}>
					<div className={styles.banner}>
						<div className={styles.bannerIcon}>
							<LockIcon />
						</div>
						<p className={styles.bannerText}>
							For your security, enter the amount from your last 3 token purchases (one for each of the past 3 months).
						</p>
					</div>

					<section className={styles.card}>
						<div className={styles.cardBody}>
							{fields.map((field, idx) => (
								<div key={field.label} className={styles.fieldGroup}>
									<label className={styles.fieldLabel}>{field.label}</label>
									<div className={styles.fieldRow}>
										<NumericFormat
											value={field.value}
											onValueChange={values => setFieldValue(idx, values.value)}
											thousandSeparator=","
											decimalSeparator="."
											decimalScale={2}
											allowNegative={false}
											placeholder="0.00"
											inputMode="decimal"
											className={styles.fieldInput}
										/>
										<div className={styles.fieldSuffix}>kWh</div>
									</div>
								</div>
							))}
							<p className={styles.hint}>
								Enter the units (kWh) you purchased over the past three months, exactly as they appear on your previous
								electricity receipts.
							</p>
						</div>
					</section>
				</div>

				<footer className={styles.footer}>
					<Button
						type="submit"
						text="Verify Tokens"
						disabled={!allFilled}
						loading={submitting}
						loadingText="Verifying…"
					/>
				</footer>
			</form>
		</CustomerPageLayout>
	);
};

export default TransferUnitVerifyMeterPage;
